/**
 * ---------------------------------------------------
 *  LINHAS DE CUIDADO ATIVAS NA INSTITUIÇÃO
 * ---------------------------------------------------
 */
export const LISTAR_LCS_REQUEST = '@carelines/LISTAR_LCS_REQUEST';
export const LISTAR_LCS_SUCCESS = '@carelines/LISTAR_LCS_SUCCESS';
export const LISTAR_LCS_FAILURE = '@carelines/LISTAR_LCS_FAILURE';

/**
 * ---------------------------------------------------
 *  CANCER DE MAMA
 * ---------------------------------------------------
 */
export const LC_CANCER_MAMA_REQUEST = '@carelines/LC_CANCER_MAMA_REQUEST';
export const LC_CANCER_MAMA_SUCCESS = '@carelines/LC_CANCER_MAMA_SUCCESS';
export const LC_CANCER_MAMA_FAILURE = '@carelines/LC_CANCER_MAMA_FAILURE';

export const GET_CANCER_MAMA_REQUEST = '@carelines/GET_CANCER_MAMA_REQUEST';
export const GET_CANCER_MAMA_SUCCESS = '@carelines/GET_CANCER_MAMA_SUCCESS';
export const GET_CANCER_MAMA_FAILURE = '@carelines/GET_CANCER_MAMA_FAILURE';

export const LC_CANCER_MAMA_UPDATE_REQUEST =
  '@carelines/LC_CANCER_MAMA_UPDATE_REQUEST';
export const LC_CANCER_MAMA_UPDATE_SUCCESS =
  '@carelines/LC_CANCER_MAMA_UPDATE_SUCCESS';
export const LC_CANCER_MAMA_UPDATE_FAILURE =
  '@carelines/LC_CANCER_MAMA_UPDATE_FAILURE';

/**
 * ---------------------------------------------------
 *  QUADRIL
 * ---------------------------------------------------
 */
export const LC_QUADRIL_REQUEST = '@carelines/LC_QUADRIL_REQUEST';
export const LC_QUADRIL_SUCCESS = '@carelines/LC_QUADRIL_SUCCESS';
export const LC_QUADRIL_FAILURE = '@carelines/LC_QUADRIL_FAILURE';

export const GET_QUADRIL_REQUEST = '@carelines/GET_QUADRIL_REQUEST';
export const GET_QUADRIL_SUCCESS = '@carelines/GET_QUADRIL_SUCCESS';
export const GET_QUADRIL_FAILURE = '@carelines/GET_QUADRIL_FAILURE';

export const LC_QUADRIL_UPDATE_REQUEST = '@carelines/LC_QUADRIL_UPDATE_REQUEST';
export const LC_QUADRIL_UPDATE_SUCCESS = '@carelines/LC_QUADRIL_UPDATE_SUCCESS';
export const LC_QUADRIL_UPDATE_FAILURE = '@carelines/LC_QUADRIL_UPDATE_FAILURE';

/**
 * ---------------------------------------------------
 *  ACIDENTE VASCULAR CEREBRAL (AVC)
 * ---------------------------------------------------
 */
export const LC_AVC_REQUEST = '@carelines/LC_AVC_REQUEST';
export const LC_AVC_SUCCESS = '@carelines/LC_AVC_SUCCESS';
export const LC_AVC_FAILURE = '@carelines/LC_AVC_FAILURE';

export const GET_AVC_REQUEST = '@carelines/GET_AVC_REQUEST';
export const GET_AVC_SUCCESS = '@carelines/GET_AVC_SUCCESS';
export const GET_AVC_FAILURE = '@carelines/GET_AVC_FAILURE';

export const LC_AVC_UPDATE_REQUEST = '@carelines/LC_AVC_UPDATE_REQUEST';
export const LC_AVC_UPDATE_SUCCESS = '@carelines/LC_AVC_UPDATE_SUCCESS';
export const LC_AVC_UPDATE_FAILURE = '@carelines/LC_AVC_UPDATE_FAILURE';

/**
 * ---------------------------------------------------
 *  CANCER DE PROSTATA
 * ---------------------------------------------------
 */
export const LC_CANCER_PROSTATA_REQUEST =
  '@carelines/LC_CANCER_PROSTATA_REQUEST';
export const LC_CANCER_PROSTATA_SUCCESS =
  '@carelines/LC_CANCER_PROSTATA_SUCCESS';
export const LC_CANCER_PROSTATA_FAILURE =
  '@carelines/LC_CANCER_PROSTATA_FAILURE';

export const GET_CANCER_PROSTATA_REQUEST =
  '@carelines/GET_CANCER_PROSTATA_REQUEST';
export const GET_CANCER_PROSTATA_SUCCESS =
  '@carelines/GET_CANCER_PROSTATA_SUCCESS';
export const GET_CANCER_PROSTATA_FAILURE =
  '@carelines/GET_CANCER_PROSTATA_FAILURE';

export const LC_CANCER_PROSTATA_UPDATE_REQUEST =
  '@carelines/LC_CANCER_PROSTATA_UPDATE_REQUEST';
export const LC_CANCER_PROSTATA_UPDATE_SUCCESS =
  '@carelines/LC_CANCER_PROSTATA_UPDATE_SUCCESS';
export const LC_CANCER_PROSTATA_UPDATE_FAILURE =
  '@carelines/LC_CANCER_PROSTATA_UPDATE_FAILURE';

/**
 * ---------------------------------------------------
 *  SEPSE
 * ---------------------------------------------------
 */
export const LC_SEPSE_REQUEST = '@carelines/LC_SEPSE_REQUEST';
export const LC_SEPSE_SUCCESS = '@carelines/LC_SEPSE_SUCCESS';
export const LC_SEPSE_FAILURE = '@carelines/LC_SEPSE_FAILURE';

export const GET_SEPSE_REQUEST = '@carelines/GET_SEPSE_REQUEST';
export const GET_SEPSE_SUCCESS = '@carelines/GET_SEPSE_SUCCESS';
export const GET_SEPSE_FAILURE = '@carelines/GET_SEPSE_FAILURE';

export const LC_SEPSE_UPDATE_REQUEST = '@carelines/LC_SEPSE_UPDATE_REQUEST';
export const LC_SEPSE_UPDATE_SUCCESS = '@carelines/LC_SEPSE_UPDATE_SUCCESS';
export const LC_SEPSE_UPDATE_FAILURE = '@carelines/LC_SEPSE_UPDATE_FAILURE';

/**
 * ---------------------------------------------------
 *  SCA
 * ---------------------------------------------------
 */
export const LC_SCA_REQUEST = '@carelines/LC_SCA_REQUEST';
export const LC_SCA_SUCCESS = '@carelines/LC_SCA_SUCCESS';
export const LC_SCA_FAILURE = '@carelines/LC_SCA_FAILURE';

export const GET_SCA_REQUEST = '@carelines/GET_SCA_REQUEST';
export const GET_SCA_SUCCESS = '@carelines/GET_SCA_SUCCESS';
export const GET_SCA_FAILURE = '@carelines/GET_SCA_FAILURE';

export const LC_SCA_UPDATE_REQUEST = '@carelines/LC_SCA_UPDATE_REQUEST';
export const LC_SCA_UPDATE_SUCCESS = '@carelines/LC_SCA_UPDATE_SUCCESS';
export const LC_SCA_UPDATE_FAILURE = '@carelines/LC_SCA_UPDATE_FAILURE';

// GRACE RISK

export const GRACE_REQUEST = '@carelines/GRACE_REQUEST';
export const GRACE_SUCCESS = '@carelines/GRACE_SUCCESS';
export const GRACE_FAILURE = '@carelines/GRACE_FAILURE';
